import { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import OtpLogin from "@/components/OtpLogin";

export default function SellerLogin() {
  const { slug } = useParams();
  const { setUser, setTenant } = useAuth();
  const nav = useNavigate();
  const [tenant, setT] = useState(null);
  useEffect(() => { api.get(`/store/${slug}`).then(({ data }) => setT(data)).catch(() => {}); }, [slug]);
  const brand = tenant?.branding?.primary_color || "#0F172A";

  return (
    <div className="min-h-screen lg:grid lg:grid-cols-2 bg-slate-50">
      <div className="relative hidden lg:flex flex-col justify-between p-12 bg-white grid-bg">
        <div>
          <div className="flex items-center gap-3 mb-12">
            {tenant?.branding?.logo_url && <img src={tenant.branding.logo_url} alt="" className="h-12 w-12 object-contain rounded p-1 border border-slate-200" />}
            <div>
              <div className="text-xs uppercase tracking-wider text-slate-500">Marketplace Seller</div>
              <div className="font-display text-xl font-bold">{tenant?.name || "Loading..."}</div>
            </div>
          </div>
          <h1 className="font-display text-4xl font-extrabold tracking-tight max-w-md text-slate-900">List products. Track earnings.</h1>
          <p className="mt-4 text-slate-600 max-w-md">Manage your inventory under {tenant?.name || "this tenant"}, view bookings, and track settlements.</p>
        </div>
        <Link to={`/t/${slug}`} className="text-xs text-slate-500 underline" data-testid="seller-login-back">← Back to storefront</Link>
      </div>

      {/* Mobile header */}
      <div className="lg:hidden bg-white border-b border-slate-200 px-5 py-4 flex items-center gap-3" data-testid="seller-login-mobile-header">
        {tenant?.branding?.logo_url ? (
          <img src={tenant.branding.logo_url} alt="" className="h-10 w-10 object-contain rounded p-1 border border-slate-200" />
        ) : (
          <div className="w-9 h-9 rounded bg-slate-900 grid place-items-center text-white font-bold text-sm">S</div>
        )}
        <div className="flex-1">
          <div className="font-display text-base font-bold leading-none truncate">{tenant?.name || "Seller Login"}</div>
          <div className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5">Marketplace Seller</div>
        </div>
        <Link to={`/t/${slug}`} className="text-xs text-slate-500 underline" data-testid="seller-login-back-mobile">Storefront</Link>
      </div>

      <div className="flex items-start sm:items-center justify-center px-4 sm:px-6 py-6 sm:py-10 min-h-[calc(100vh-72px)] lg:min-h-screen">
        <OtpLogin
          scope="seller"
          tenantSlug={slug}
          brandColor={brand}
          title="Seller sign in"
          subtitle={`Demo phone: 9111100001 (aquapure), 9111100002/03 (drivex), 9111100004 (kasturi)`}
          testIdPrefix="seller-login"
          onSuccess={(data) => { setUser(data.user); setTenant(data.tenant); nav(`/tenant/${slug}/seller`); }}
        />
      </div>
    </div>
  );
}
